import {COOKIE_TYPE} from './utils/cookieType';

export default [
  {
    id: 1,
    name: COOKIE_TYPE.ESSENTIAL,
    title: 'Essential cookies',
    description:
      'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.',
    isMandatory: true,
  },
  {
    id: 2,
    name: COOKIE_TYPE.PERFORMANCE,
    title: 'Performance cookies',
    description:
      'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.',
    isMandatory: false,
  },
  {
    id: 3,
    name: COOKIE_TYPE.MARKETING,
    title: 'Marketing cookies',
    description:
      'These cookies track your activity around the site to measure the performance of our marketing campaigns, and to help us deliver more relevant marketing communications, such as internet-based advertising, retargeting, and social media ads. In order to do so, these cookies share some of your personal data with third parties like Google Ads, Meta Ads, and TradeDoubler.',
    isMandatory: false,
  },
];
